import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useUser = () => useQuery({ queryKey: [`user`], queryFn: async () => {
    const callback = await API.get(`/me`)
    return callback?.data
}, staleTime: 1000 * 60, gcTime: 1000 * 60 * 60 * 60 * 24 })

export default useUser